module.exports = __webpack_public_path__ + "img/cat_dl.14da8297.jpg";